import React from 'react'
import PropTypes from 'prop-types'
import Spinner from 'react-spinkit'

import 'styles/Loading.css'
import strings from 'utils/strings.js'

export default function Loading(props) {
  let className = 'loading-area'
  let spinnerClassName = 'loading-area_spinner'
  if (props.size) {
    className += ` loading-area--${props.size}`
    spinnerClassName += ` loading-area_spinner--${props.size}`
  }

  if (props.contained) {
    className = 'contained'
  }

  return (
    <div style={props.style} className={className}>
      <Spinner name="cube-grid" className={spinnerClassName} />
      <span className="loading-area_text">{props.message}</span>
    </div>
  )
}

Loading.defaultProps = {
  message: strings.loading,
  style: {},
}

Loading.propTypes = {
  message: PropTypes.string,
  size: PropTypes.string,
  contained: PropTypes.bool,
  style: PropTypes.object,
}
